import cookie from "react-cookies";
import { environment } from "../common/sysco-ui-components/config/constant";
import Axios from "axios";
import { SUPPLIER_PATH } from "./path";

export const DP_ENV = environment();

export function prodLogin() {
  if (environment() === '-dev') {
    return '-np';
  } else return ""
}

export async function  getToken(){
  const res= await Axios({
    url: `${SUPPLIER_PATH}/get-otds-token`,
    method: "GET",
    headers: {
      "Access-Control-Allow-Origin": "*"
    }  })
    .then(response => {
      cookie.save("serviceToken", response.data.otdsToken, { path: "/" });
      return response.data.otdsToken
    })
    .catch(err => { 
      return null
    })
    return await res
}
